export default __webpack_public_path__ + "static/media/laptop-calendar-clock.5034e294.png";